import { render } from "./BlogPostRestrictedVisibility.vue?vue&type=template&id=24abdc04"
import script from "./BlogPostRestrictedVisibility.vue?vue&type=script&lang=js"
export * from "./BlogPostRestrictedVisibility.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__